import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'ramda';

// Components
import {
  I18n,
  TabsList,
  Tab,
  Link,
} from 'components';
import classNames from 'classnames/bind';
import ExpensesFilters from '../ExpensesFilters';
import SpendingStructureTable from '../SpendingStructureTable';
import DetailsTable from '../DetailsTable';

// Constants
import { EXPENSES_SECTIONS } from '../../constants';

// Styles
import styles from './styles.pcss';
const cx = classNames.bind(styles);

const getChildren = (filterId, filters) => {
  const initialFilters = filters;
  const filterIndex = initialFilters.findIndex(({ id } = {}) => id === filterId);
  const filter = initialFilters[filterIndex];

  delete initialFilters[filterIndex];

  if (filter.childrenIds) {
    filter.children = filter.childrenIds
      .map((id) => getChildren(id, initialFilters));
  }

  return filter;
};

const getFilters = (filters) => {
  const result = [];

  filters.forEach((filter) => filter && result.push(getChildren(filter.id, filters)));

  return result;
};

class ExpensesTabs extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: EXPENSES_SECTIONS.STRUCTURE,
      areFiltersVisible: false,
    };
  }

  applyFilters = () => {
    const {
      spendingStructure,
      details,
      filters,
      onlyFreeActions,
    } = this.props;
    const { activeTab } = this.state;
    const items = activeTab === EXPENSES_SECTIONS.STRUCTURE ? spendingStructure : details;

    return (
      items.filter(({ filterId, value }) => {
        const filter = filters.find(({ id }) => id === filterId);
        const skipFreeActions = activeTab === EXPENSES_SECTIONS.DETALIZATION
          && onlyFreeActions && !value;

        return !skipFreeActions && (!filter || filter.activeIn[activeTab]);
      })
    );
  };

  render() {
    const {
      filters,
      onlyFreeActions,
      toggleFilter,
      toggleOnlyPaidFilter,
      postpaid,
      showUserNumber,
      onChangeActiveTab,
      currency,
      isPorted,
    } = this.props;

    const {
      activeTab,
      areFiltersVisible,
    } = this.state;

    const filtersArray = getFilters([...filters]);

    return (
      <div className={cx('component')}>
        <div className={cx('header')}>
          <TabsList
            className={cx('tabs')}
            type="segmented"
            activeTab={activeTab}
            handleTabClick={(value) => {
              this.setState({ activeTab: value });

              if (onChangeActiveTab) {
                onChangeActiveTab(value);
              }
            }}
          >
            <Tab className={cx('expensesTab')} id={EXPENSES_SECTIONS.STRUCTURE}>
              <I18n path="detalization.expenses.structureLink" />
            </Tab>
            <Tab className={cx('expensesTab')} id={EXPENSES_SECTIONS.DETALIZATION}>
              <I18n path="detalization.expenses.detailsLink" />
            </Tab>
          </TabsList>

          {!isPorted && !isEmpty(filtersArray) && (
            <Link
              onClick={() => this.setState({ areFiltersVisible: !areFiltersVisible })}
            >
              <I18n path="detalization.expenses.reportSettings" />
            </Link>
          )}
        </div>

        {areFiltersVisible && (
          <ExpensesFilters
            className={cx('expensesFilters')}
            section={activeTab}
            filters={filtersArray}
            onlyFreeActions={onlyFreeActions}
            toggleFilter={toggleFilter}
            toggleOnlyPaidFilter={
              activeTab === EXPENSES_SECTIONS.DETALIZATION && toggleOnlyPaidFilter
            }
          />
        )}

        {activeTab === EXPENSES_SECTIONS.STRUCTURE && (
          <SpendingStructureTable
            structure={this.applyFilters()}
            currency={currency}
            isPorted={isPorted}
          />
        )}

        {activeTab === EXPENSES_SECTIONS.DETALIZATION && (
          <DetailsTable
            postpaid={postpaid}
            showUserNumber={showUserNumber}
            details={this.applyFilters()}
            currency={currency}
            isPorted={isPorted}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isPorted: state.application.isPorted,
});

ExpensesTabs.propTypes = {
  filters: PropTypes.array,
  details: PropTypes.array,
  spendingStructure: PropTypes.array,
  toggleFilter: PropTypes.func,
  toggleOnlyPaidFilter: PropTypes.func,
  postpaid: PropTypes.bool,
  showUserNumber: PropTypes.bool,
  onChangeActiveTab: PropTypes.func,
  currency: PropTypes.string,
  onlyFreeActions: PropTypes.bool,
  isPorted: PropTypes.bool,
};

export default connect(mapStateToProps)(ExpensesTabs);
